<template>
  <Empty :text="text" :loading="loading" :imgSrc="require('@/assets/nopost.svg')" />
</template>
<script>
import Empty from '@/components/Empty.vue'

export default {
  components: {
    Empty,
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '暂无产品'
    },
  },
}
</script>
<style lang="">
  
</style>